import styled from 'styled-components';

import Input from 'components/Form/Input';

import { useAccount } from 'context/AccountProvider';

import BREAKPOINTS from 'styles/breakpoints';
import { H2, fluidType } from 'styles/typography';

import PageLayout from './PageLayout';

const MAX_WIDTH_SMALL = '360px';
const MAX_WIDTH_LARGE = '874px';

const Title = styled(H2)`
  margin-bottom: 30px;
  text-align: center;

  ${BREAKPOINTS.medium`
    margin-top: ${fluidType(40, 70)};
  `}
`;

const Form = styled.form`
  margin: 0 auto;
  max-width: ${MAX_WIDTH_LARGE};
`;

const Inner = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Column = styled.div`
  margin: 0 var(--gutter-side) 21px;
  width: 100%;
  max-width: ${MAX_WIDTH_SMALL};

  ${BREAKPOINTS.small`
    margin-bottom: 35px;

    &:first-child {
      margin-right: 20px;
    }

    &:last-child {
      margin-left: 20px;
    }
  `}
`;

const Profile = () => {
  const { firstName, lastName, email } = useAccount();
  return (
    <PageLayout>
      <Title as="h1">My Details</Title>

      <Form>
        <Inner>
          <Column>
            <Input
              label="First name"
              field="firstName"
              defaultValue={firstName}
              isDisabled
              theme="light"
            />

            <Input
              label="Last name"
              field="lastName"
              defaultValue={lastName}
              isDisabled
              theme="light"
            />

            <Input
              label="Email address"
              field="email"
              type="email"
              defaultValue={email}
              isDisabled
              theme="light"
            />
          </Column>
        </Inner>
      </Form>
    </PageLayout>
  );
};

export default Profile;
